import { useLayoutEffect } from 'react'
import { Link } from 'react-router-dom'
import HeroArtGrid from '../components/sections/HeroArtGrid/HeroArtGrid'
import { HERO_ART } from '../config/heroArt'
import { ContentColumn } from '../components/layout/ContentColumn/ContentColumn'

export default function ContactPage() {
  useLayoutEffect(() => {
    const measure = () => {
      const headerEl = document.querySelector('header') as HTMLElement | null
      const stickyNavEl = document.querySelector('.sticky.top-0') as HTMLElement | null
      const headerH = headerEl?.offsetHeight ?? 0
      const navH = stickyNavEl?.offsetHeight ?? 0
      const offset = headerH + navH
      document.documentElement.style.setProperty('--header-nav-height', `${offset}px`)
    }
    measure()
    requestAnimationFrame(measure)
    window.addEventListener('resize', measure)
    return () => window.removeEventListener('resize', measure)
  }, [])

  return (
    <>
      <div className="bg-gray-50 min-h-screen text-[#232323]">
        <section className="relative overflow-hidden bg-brand-navy py-20 md:py-28">
          <ContentColumn anchor="contact-hero" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid lg:grid-cols-2 gap-10 lg:gap-14 items-center">
            <div className="max-w-3xl">
              <h1 className="font-sans text-[42px] sm:text-[48px] md:text-[56px] font-bold text-gray-50 mb-6 leading-[1.3] tracking-[-0.02em]">
                Let's talk
              </h1>
              <p className="text-[21px] leading-[1.58] text-gray-50/85 font-body mb-10">
                Want to work together, book a mentorship session, or just say hello? Drop me a line.
              </p>
            </div>
            <HeroArtGrid images={HERO_ART.contact} />
            </div>
          </ContentColumn>
        </section>

        <section className="border-b border-border-subtle bg-white">
          <div className="max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-4">
            <nav aria-label="Breadcrumb">
              <ol className="flex items-center gap-2 text-label font-body text-gray-900/60">
                <li>
                  <Link to="/" className="transition-colors hover:text-gray-900 focus:text-gray-900 focus:outline-none">
                    Home
                  </Link>
                </li>
                <li className="font-heading text-gray-900">/</li>
                <li className="font-heading text-gray-900" aria-current="page">
                  Contact
                </li>
              </ol>
            </nav>
          </div>
        </section>

        <section className="bg-white py-20">
          <ContentColumn anchor="contact-main" className="max-w-4xl mx-auto px-4">
            <div className="bg-white border-2 border-gray-200 rounded-smooth-lg p-8 sm:p-12 shadow-sm">
              <h2 className="font-heading text-3xl font-bold uppercase text-gray-900 mb-6">
                Reach out
              </h2>

              <div className="space-y-6">
                <div>
                  <h3 className="font-heading text-lg font-semibold uppercase text-gray-900 mb-2">
                    Email
                  </h3>
                  <p className="font-body text-base text-ink-soft">
                    The fastest way to reach me:{' '}
                    <a
                      href="mailto:me@gazar.dev"
                      className="text-brand-navy hover:underline font-semibold"
                    >
                      me@gazar.dev
                    </a>
                  </p>
                </div>

                <div>
                  <h3 className="font-heading text-lg font-semibold uppercase text-gray-900 mb-2">
                    Company
                  </h3>
                  <p className="font-body text-base text-ink-soft">
                    <strong>QUEEK LIMITED</strong>
                    <br />
                    gazar.dev is operated by QUEEK LIMITED.
                  </p>
                </div>
              </div>
            </div>
          </ContentColumn>
        </section>
      </div>
    </>
  )
}
